import { LabMDM } from "../masterdata/models/lab";

export class Sample {
    _id: string
    materialType: string
    creationDate: number
    lastModifiedDate: number
    version: number
    type: string
    barcode: string
    initialVolume: number
    remainingVolume: number
    orderItemId: string
    container: string
    lab: LabMDM
    concentrationMeasurementRequired: boolean
    /** The measured volumes. */
    measuredVolumes: number[];

    /** The target volume. */
    targetVolume: number;

    /** The active. */
    active: boolean;

    /**Tag for Volume Change */
    volumeChanged: boolean;

    processStep: string;

    constructor() {
        this.type = 'Sample'
    }

}
export enum OriginalMaterialType {

    /** The premixed dna. */
    PREMIXED_DNA = "PREMIXED_DNA",

    /** The purified dna. */
    PURIFIED_DNA = "PURIFIED_DNA",

    /** The clone. */
    CLONE = "CLONE",

    /** The unpurified pcr. */
    UNPURIFIED_PCR = "UNPURIFIED_PCR",

    /** The Ready to load. */
    READY_TO_LOAD = "READY_TO_LOAD"

}